/* eslint-disable handle-callback-err */
/**
 * WebSocket Module
 */
import SockJS from 'sockjs-client'
import Stomp from 'stomp-websocket'
import helper from 'util/helpers'
import eventBus from '../../../event_bus'
const baseUrl = process.env.BASE_URL

const getDefaultState = () => {
  return {
    stompClient: null,
    isConnecting: false,
    isConnected: false,
    connectTrigger: 1,
    subscriptions: []
  }
}
const state = getDefaultState()

const getters = {
  IS_CONNECTED: (state) => { return state.isConnected }
}
const mutations = {
  START_CONNECT (state) {
    state.isConnecting = true
  },
  END_CONNECT (state) {
    state.isConnecting = false
    state.isConnected = true
    state.stompClient.connected = true
    return true
  },
  FAIL_CONNECT (state) {
    state.isConnecting = false
    state.isConnected = false
    if (state.stompClient) {
      state.stompClient.connected = false
    } else {
      state.stompClient = null
    }
  },

  subscribe (state, payload) {
    let subscription = helper.findByKey(state.subscriptions, payload.key)
    if (subscription === undefined) {
      subscription = state.stompClient.subscribe(payload.subscribeUrl, tick => payload.callback(JSON.parse(tick.body), payload.chatRoom))
      const newSubscription = {
        key: payload.key,
        chatRoomId: payload.chatRoomId,
        subscriptionUrl: payload.subscribeUrl,
        id: subscription.id,
        subscription: subscription
      }
      state.subscriptions.push(newSubscription)
    }
    return subscription.id
  },
  closeSubscriptionWithPrefix (state, prefix) {
    let filtered = state.subscriptions
      .filter(e => e.key.includes(prefix))

    state.subscriptions = state.subscriptions
      .filter(e => !e.key.includes(prefix))
    filtered.forEach(releasable => {
      releasable.subscription.unsubscribe()
    })
  },
  forceCloseConnection (state) {
    if (state.subscriptions.length > 0) {
      console.log('모든 소켓 종료')
      state.subscriptions.forEach(releasable => {
        releasable.subscription.unsubscribe()
      })
      state.subscriptions = []
    }
  }
}

const actions = {
  async connect ({commit, state}) {
    if (state.isConnecting) {
      return false
    }
    commit('START_CONNECT')
    state.stompClient = Stomp.over(new SockJS(baseUrl + '/api/webSocket'))
    if (process.env.NODE_ENV === 'production') {
      state.stompClient.debug = null
    }
    state.stompClient.connect(
      {},
      frame => {
        commit('END_CONNECT')
        eventBus.$emit('socket-connection-success')
        return true
      },
      error => {
        console.log('끊김', error)
        commit('forceCloseConnection')
        commit('FAIL_CONNECT')
        eventBus.$emit('reconnect-start')
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/webSocket/index.js